import React from "react";
const IcoActive = (color: "#696969") =>
  `<svg id="Componente_1107_3" data-name="Componente 1107 – 3" xmlns="http://www.w3.org/2000/svg" width="14.931" height="15.428" viewBox="0 0 14.931 15.428">
  <path id="Caminho_3707" data-name="Caminho 3707" d="M24.461,1A1,1,0,1,0,22.47,1V7.963a1,1,0,1,0,1.991,0ZM19.966,3.751a1,1,0,1,0-1.275-1.53,7.467,7.467,0,1,0,9.546,0,1,1,0,1,0-1.275,1.53,5.475,5.475,0,1,1-7,0Z" transform="translate(-16 0)" fill="`+color+`"/>
</svg>`;


export default IcoActive
